"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.16654 7.49992V14.1666M7.91653 7.49992V14.1666M12.0832 7.49992V14.1666M15.8332 7.49992V14.1666M2.49988 15.4999L2.49988 16.1666C2.49988 16.6333 2.49988 16.8666 2.59071 17.0449C2.6706 17.2017 2.79808 17.3292 2.95488 17.4091C3.13314 17.4999 3.3665 17.4999 3.83321 17.4999H16.1665C16.6332 17.4999 16.8666 17.4999 17.0448 17.4091C17.2016 17.3292 17.3291 17.2017 17.409 17.0449C17.4998 16.8666 17.4998 16.6333 17.4998 16.1666V15.4999C17.4998 15.0332 17.4998 14.7998 17.409 14.6216C17.3291 14.4648 17.2016 14.3373 17.0448 14.2574C16.8666 14.1666 16.6332 14.1666 16.1665 14.1666H3.83321C3.3665 14.1666 3.13314 14.1666 2.95488 14.2574C2.79808 14.3373 2.6706 14.4648 2.59071 14.6216C2.49988 14.7998 2.49988 15.0332 2.49988 15.4999ZM9.71061 2.56421L3.54397 3.93458C3.17142 4.01736 2.98514 4.05876 2.8461 4.15893C2.72345 4.24729 2.62715 4.36734 2.5675 4.50623C2.49988 4.6637 2.49988 4.85452 2.49988 5.23615L2.49988 6.16659C2.49988 6.6333 2.49988 6.86665 2.59071 7.04491C2.6706 7.20171 2.79808 7.3292 2.95488 7.40909C3.13314 7.49992 3.3665 7.49992 3.83321 7.49992H16.1665C16.6332 7.49992 16.8666 7.49992 17.0448 7.40909C17.2016 7.3292 17.3291 7.20171 17.409 7.04491C17.4998 6.86665 17.4998 6.6333 17.4998 6.16659V5.23615C17.4998 4.85452 17.4998 4.6637 17.4322 4.50623C17.3726 4.36734 17.2762 4.24729 17.1536 4.15893C17.0146 4.05876 16.8283 4.01737 16.4557 3.93458L10.2891 2.56421C10.1812 2.54022 10.1272 2.52823 10.0726 2.52345C10.0242 2.5192 9.97549 2.5192 9.92705 2.52345C9.87252 2.52823 9.81855 2.54022 9.71061 2.56421Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;